import { useNavigate } from 'react-router';
import { buildB2BOpportunitiesUrl } from '~/routing';
import type { JobResponse } from '~/types/hlx/jobResponse';
import { b2bSideCopy } from '../../b2bSideCopy';
import { NegotiationDetails } from '../../negotiations/NegotiationDetails';

const copy = b2bSideCopy('OFFERING');

/**
 * "Request this labor" (DD17): the offer editor, prefilled from the listing's terms. Nothing is
 * sent until the buyer clicks Send request. The buyer attaches no providers (the seller's roster
 * is what is on offer), and afterwards lands on that row under Responses → Buying → Sent.
 */
export const OfferingRequestEditor = ({
  listingId,
  onSubmitted,
  onClose,
}: {
  listingId: number;
  onSubmitted: (jobResponse: JobResponse) => void;
  onClose: () => void;
}) => {
  const navigate = useNavigate();
  return (
    <>
      <p>{copy.negotiateIntro}</p>
      <NegotiationDetails
        draftSource={{ listingType: 'MSAAS', listingId }}
        viewerRole="EMPLOYER"
        listingSide="OFFERING"
        submitLabels={{
          submit: copy.submitOffer,
          submitting: copy.submittingOffer,
          retry: copy.retryOffer,
        }}
        onDraftSubmitted={(result) => {
          onSubmitted(result.jobResponse);
          navigate(
            buildB2BOpportunitiesUrl({
              view: 'sent',
              side: 'buying',
              responseId: result.jobResponse.id,
            })
          );
        }}
        onClose={onClose}
      />
    </>
  );
};
